import { inject, Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { EmployeeService } from 'src/app/services/employee.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { UtilsService } from 'src/app/services/utils.service';

@Injectable({ providedIn: 'root' })
export class RrhhRemoteWorkGuard implements CanActivate {
  private readonly permissions = inject(PermissionsService);
  private readonly employee = inject(EmployeeService);
  private readonly utils = inject(UtilsService);

  async canActivate(): Promise<boolean | UrlTree> {
    if (this.permissions.validateDepartment(['direction', 'rrhh'])) {
      return true;
    }

    if (this.isRemoteWorkResponsible()) {
      return true;
    }

    await this.waitUntilActionsRequiredIsReady();

    if (this.isRemoteWorkResponsible()) {
      return true;
    }

    return true;
  }

  private isRemoteWorkResponsible(): boolean {
    return this.employee.actionsRequired().is_remote_work_responsible;
  }

  private async waitUntilActionsRequiredIsReady(attempt = 0): Promise<void> {
    if (attempt >= 30) {
      return;
    }

    if (typeof this.employee.actionsRequired().is_remote_work_responsible === 'boolean') {
      return;
    }

    await this.utils.sleep(100);

    return this.waitUntilActionsRequiredIsReady(attempt + 1);
  }
}
